module.exports = __webpack_public_path__ + "img/ic_food_function_canteen_tabes_img3.e51509ea.png";